export const dashboardDailyReportTour = {
  key: "dashboardDailyReport",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="dailyreport-hero"]',
      content: t("Tour_DailyReport_Hero"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="dailyreport-boardpicker"]',
      content: t("Tour_DailyReport_BoardPicker"),
      placement: "bottom",
    },
    {
      target: '[data-tour="dailyreport-form"]',
      content: t("Tour_DailyReport_Form"),
      placement: "top",
    },
  ],
};
